import ReferralTool from './component';
/* eslint-disable no-new */

new ReferralTool({
  target: document.getElementById('related-links-container')
});